import Chip from '@mui/material/Chip';
import { chooseColor } from '../../utils/colors';
import { useTranslation } from 'react-i18next';

const colorMap = new Map([
  [true, '#429D42'],
  [false, '#C0641B'],

]);

const statusColor = (status) => {
  return colorMap.get(status)
};


function StatusChip({ status }) {
  const color = statusColor(status);
  const { t } = useTranslation();

  return <Chip label={status ? t('freigegeben', { ns: 'statusOverviewPage', defaultValue: 'Freigegeben'}) : t('NichtFreigegeben', { ns: 'statusOverviewPage', defaultValue: 'Nicht Freigegeben'}) } sx={{ backgroundColor: color, color: chooseColor(color) }} />
}

export default StatusChip
